import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeSession } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const user = await exchangeSession(sessionId);
        // Clean hash from URL
        window.history.replaceState({}, document.title, "/admin");
        navigate("/admin", { replace: true, state: { user } });
      } catch (e) {
        setError("Could not complete sign-in. Please try again.");
        setTimeout(() => navigate("/admin/login", { replace: true }), 2000);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 text-slate-700">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-7 w-7 animate-spin text-cyan-600" />
        <div className="text-sm font-medium">
          {error || "Signing you in..."}
        </div>
      </div>
    </div>
  );
}
